import { render, staticRenderFns } from "./MasterDiscussion.vue?vue&type=template&id=40a821bc&"
import script from "./MasterDiscussion.vue?vue&type=script&lang=js&"
export * from "./MasterDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports